import React from 'react';
import { Container, Row, Col, Button, Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { FaArrowRight, FaCheckCircle, FaPhone, FaClock, FaAward, FaUsers, FaStar, FaQuoteLeft, FaShieldAlt, FaTools, FaHandshake, FaHeadset } from 'react-icons/fa';
import Slider from '../components/Slider';
import './Home.css';
import mbarblepolishing from "../images/mbarble-polishing.png"
import deepCleaning from '../images/deep-cleaning.png';
import officehouserenovation from '../images/office-house-renovation.png';

const Home = () => {
  const featuredServices = [
    {
      id: 1,
      title: 'Marble Polishing',
      description: 'Professional marble restoration and polishing services',
      icon: mbarblepolishing
    },
    {
      id: 2,
      title: 'Deep Cleaning',
      description: 'Comprehensive deep cleaning for homes and offices',
      icon: deepCleaning
    },
    {
      id: 3,
      title: 'Renovation',
      description: 'Complete renovation services with modern design',
      icon: officehouserenovation
    }
  ];

  const stats = [
    { number: '500+', label: 'Projects Completed', icon: <FaAward /> },
    { number: '10+', label: 'Years Experience', icon: <FaClock /> },
    { number: '200+', label: 'Happy Clients', icon: <FaUsers /> },
    { number: '50+', label: 'Expert Team', icon: <FaCheckCircle /> }
  ];

  const features = [
    '24/7 Emergency Service',
    'Licensed & Insured',
    '100% Satisfaction Guaranteed',
    'Free Estimates',
    'Expert Technicians',
    'Affordable Pricing'
  ];

  return (
    <div className="home-page">
      {/* Slider Section */}
      <Slider />

      {/* Stats Section */}
      <section className="stats-section">
        <Container>
          <Row className="g-4">
            {stats.map((stat, index) => (
              <Col key={index} lg={3} md={6}>
                <div className="stat-card">
                  <div className="stat-icon">{stat.icon}</div>
                  <h3 className="stat-number">{stat.number}</h3>
                  <p className="stat-label">{stat.label}</p>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* Why Choose Us Section */}
      <section className="why-choose-section">
        <Container>
          <Row>
            <Col lg={12} className="text-center mb-5">
              <span className="section-badge">Why Choose Us</span>
              <h2 className="section-title">What Makes Us Different</h2>
              <p className="section-subtitle">
                We are committed to delivering exceptional service quality and customer satisfaction
              </p>
            </Col>
          </Row>
          <Row className="g-4">
            <Col lg={3} md={6}>
              <Card className="why-card h-100">
                <Card.Body className="text-center p-4">
                  <div className="why-icon">
                    <FaAward />
                  </div>
                  <Card.Title className="why-title">Award Winning</Card.Title>
                  <Card.Text className="why-description">
                    Recognized for excellence in service delivery and customer satisfaction
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
            <Col lg={3} md={6}>
              <Card className="why-card h-100">
                <Card.Body className="text-center p-4">
                  <div className="why-icon">
                    <FaShieldAlt />
                  </div>
                  <Card.Title className="why-title">Licensed & Insured</Card.Title>
                  <Card.Text className="why-description">
                    Fully licensed, bonded, and insured for your peace of mind
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
            <Col lg={3} md={6}>
              <Card className="why-card h-100">
                <Card.Body className="text-center p-4">
                  <div className="why-icon">
                    <FaTools />
                  </div>
                  <Card.Title className="why-title">Expert Team</Card.Title>
                  <Card.Text className="why-description">
                    Skilled professionals with years of experience in their fields
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
            <Col lg={3} md={6}>
              <Card className="why-card h-100">
                <Card.Body className="text-center p-4">
                  <div className="why-icon">
                    <FaHandshake />
                  </div>
                  <Card.Title className="why-title">100% Guarantee</Card.Title>
                  <Card.Text className="why-description">
                    We guarantee our work and ensure complete customer satisfaction
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Featured Services Section */}
      <section className="featured-services-section">
        <Container>
          <Row>
            <Col lg={12} className="text-center mb-5">
              <span className="section-badge">Our Services</span>
              <h2 className="section-title">What We Offer</h2>
              <p className="section-subtitle">
                Comprehensive professional services to meet all your needs
              </p>
            </Col>
          </Row>
          <Row className="g-4">
            {featuredServices.map((service) => (
              <Col key={service.id} lg={4} md={6}>
                <Card className="service-card-featured h-100">
                  <Card.Body className="p-4">
                    <div className="service-icon-large">
                      <img className='w-100' src={service.icon} alt={service.title}/>
                    </div>
                    <Card.Title className="service-title">{service.title}</Card.Title>
                    <Card.Text className="service-description">{service.description}</Card.Text>
                    <Link to="/services" className="service-link">
                      Learn More <FaArrowRight className="ms-2" />
                    </Link>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
          <Row className="mt-5">
            <Col lg={12} className="text-center">
              <Button as={Link} to="/services" variant="outline-primary" size="lg">
                View All Services
              </Button>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Testimonials Section */}
      <section className="testimonials-section">
        <Container>
          <Row>
            <Col lg={12} className="text-center mb-5">
              <span className="section-badge">Testimonials</span>
              <h2 className="section-title">What Our Clients Say</h2>
              <p className="section-subtitle">
                Don't just take our word for it - hear from our satisfied customers
              </p>
            </Col>
          </Row>
          <Row className="g-4">
            <Col lg={4} md={6}>
              <Card className="testimonial-card h-100">
                <Card.Body className="p-4">
                  <div className="testimonial-rating">
                    {[...Array(5)].map((_, i) => (
                      <FaStar key={i} className="star-icon" />
                    ))}
                  </div>
                  <FaQuoteLeft className="quote-icon" />
                  <Card.Text className="testimonial-text">
                    "Excellent service! The team was professional, punctual, and did an amazing job 
                    with our marble polishing. Highly recommended!"
                  </Card.Text>
                  <div className="testimonial-author">
                    <div className="author-avatar">RK</div>
                    <div className="author-info">
                      <h6 className="author-name">Rajesh Kumar</h6>
                      <p className="author-role">Homeowner</p>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Col>
            <Col lg={4} md={6}>
              <Card className="testimonial-card h-100">
                <Card.Body className="p-4">
                  <div className="testimonial-rating">
                    {[...Array(5)].map((_, i) => (
                      <FaStar key={i} className="star-icon" />
                    ))}
                  </div>
                  <FaQuoteLeft className="quote-icon" />
                  <Card.Text className="testimonial-text">
                    "Outstanding renovation work! They transformed our office space completely. 
                    The quality and attention to detail is exceptional."
                  </Card.Text>
                  <div className="testimonial-author">
                    <div className="author-avatar">PM</div>
                    <div className="author-info">
                      <h6 className="author-name">Priya Mehta</h6>
                      <p className="author-role">Business Owner</p>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Col>
            <Col lg={4} md={6}>
              <Card className="testimonial-card h-100">
                <Card.Body className="p-4">
                  <div className="testimonial-rating">
                    {[...Array(5)].map((_, i) => (
                      <FaStar key={i} className="star-icon" />
                    ))}
                  </div>
                  <FaQuoteLeft className="quote-icon" />
                  <Card.Text className="testimonial-text">
                    "Best cleaning service we've ever used! They are thorough, reliable, and 
                    always on time. Our space has never looked better."
                  </Card.Text>
                  <div className="testimonial-author">
                    <div className="author-avatar">AS</div>
                    <div className="author-info">
                      <h6 className="author-name">Amit Sharma</h6>
                      <p className="author-role">Property Manager</p>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Process Section */}
      <section className="process-section">
        <Container>
          <Row>
            <Col lg={12} className="text-center mb-5">
              <span className="section-badge">Our Process</span>
              <h2 className="section-title">How We Work</h2>
              <p className="section-subtitle">
                Simple steps to get your project started
              </p>
            </Col>
          </Row>
          <Row className="g-4">
            <Col lg={3} md={6}>
              <div className="process-step">
                <div className="process-number">01</div>
                <div className="process-icon">
                  <FaHeadset />
                </div>
                <h4 className="process-title">Contact Us</h4>
                <p className="process-description">
                  Get in touch via phone, email, or our contact form
                </p>
              </div>
            </Col>
            <Col lg={3} md={6}>
              <div className="process-step">
                <div className="process-number">02</div>
                <div className="process-icon">
                  <FaTools />
                </div>
                <h4 className="process-title">Free Consultation</h4>
                <p className="process-description">
                  We assess your needs and provide a detailed quote
                </p>
              </div>
            </Col>
            <Col lg={3} md={6}>
              <div className="process-step">
                <div className="process-number">03</div>
                <div className="process-icon">
                  <FaHandshake />
                </div>
                <h4 className="process-title">Agreement</h4>
                <p className="process-description">
                  We finalize the details and schedule your service
                </p>
              </div>
            </Col>
            <Col lg={3} md={6}>
              <div className="process-step">
                <div className="process-number">04</div>
                <div className="process-icon">
                  <FaCheckCircle />
                </div>
                <h4 className="process-title">Completion</h4>
                <p className="process-description">
                  We deliver quality work and ensure your satisfaction
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <Container>
          <Row className="align-items-center">
            <Col lg={8}>
              <h2 className="cta-title">Ready to Get Started?</h2>
              <p className="cta-description">
                Contact us today for a free estimate and let us help you with your project.
              </p>
            </Col>
            <Col lg={4} className="text-lg-end">
              <Button href="tel:+919560424647" variant="light" size="lg" className="cta-button">
                <FaPhone className="me-2" />
                Contact Us Now
              </Button>
            </Col>
          </Row>
        </Container>
      </section>
    </div>
  );
};

export default Home;

